import script from "./ModalContact.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalContact.vue?vue&type=script&setup=true&lang=js"

import "./ModalContact.vue?vue&type=style&index=0&id=e62b0f24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e62b0f24"]])

export default __exports__